import Card, { CardProps } from '.';
import { CardProductProps } from './CardProduct';

interface CardProductListProps extends CardProps {
  products: CardProductProps[];
  numberOfColumns: number;
  cardWidth?: number | string;
  cardHeight?: number | string;
  gap?: number;
}

export default function CardProductList({
  products,
  className = '',
  children,
  numberOfColumns,
  cardWidth = '1fr',
  cardHeight,
  gap = 100,
  ...rest
}: CardProductListProps) {
  return (
    <Card
      className={`card-product-list ${className}`}
      style={{
        gridTemplateColumns: `repeat(${numberOfColumns}, ${cardWidth})`,
        gap,
      }}
      {...rest}
    >
      {products.map((product, index) => (
        <Card.Product
          key={index}
          style={{
            height: cardHeight,
          }}
          {...product}
        />
      ))}
      {children}
    </Card>
  );
}
